import React from 'react'
import { toast } from 'react-toastify'

export const ToastError = (error) => {
    let errorCode = `Hata Kodu: ${error?.code}` 
    let errorMessage = `Hata Mesajı: ${error?.message}` 
    return(
toast.error(`Hata Kodu: ${errorCode} \n Hata Mesajı: ${errorMessage}`,
        {
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'dark',
            position: 'top-center',

        })
    )
    

}
